import useDiscountStore from "@/store/discount";
import { notifications } from "@mantine/notifications";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { discountService } from "..";
import { CreateDiscountGroupPayload } from "../type";

function useCreateDiscountByDiscountGroup() {
  const navigate = useNavigate();
  const { clearDiscount } = useDiscountStore();
  return useMutation({
    mutationFn: (command: CreateDiscountGroupPayload) => {
      return discountService.createDiscountByDiscountGroup(command);
    },
    onSuccess: () => {
      notifications.show({
        title: "عملیات موفق",
        message: "عملیات با موفقیت صورت پذیرفت",
        color: "green",
      });
      navigate("/", { replace: true });
      clearDiscount();
    },
  });
}

export default useCreateDiscountByDiscountGroup;
